import React from 'react';

interface SectorPerformanceTableProps {
    sectorData: any[];
    theme: any;
}

export const SectorPerformanceTable: React.FC<SectorPerformanceTableProps> = ({ sectorData, theme }) => {
    // Sort by YTD performance descending
    const sortedSectors = [...sectorData]
        .filter(s => s.count > 0)
        .sort((a, b) => (b.avgYtd ?? 0) - (a.avgYtd ?? 0));

    return (
        <div style={{ height: '100%', overflow: 'auto' }}>
            <table className='data-table' style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th className='left' style={{ color: theme.sub }}>Secteur</th>
                        <th className='right' style={{ color: theme.sub }}>Perf Moy (YTD)</th>
                        <th className='right' style={{ color: theme.sub }}>Nb Titres</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedSectors.map((s) => (
                        <tr key={s.sector}>
                            <td className='left' style={{ color: theme.text, fontWeight: 'bold' }}>
                                {s.sector}
                            </td>
                            <td className='right' style={{
                                color: (s.avgYtd ?? 0) >= 0 ? '#00b638' : '#ef5350',
                                fontWeight: 'bold'
                            }}>
                                {(s.avgYtd ?? 0) > 0 ? '+' : ''}{(s.avgYtd ?? 0).toFixed(2)}%
                            </td>
                            <td className='right' style={{ color: theme.sub }}>
                                {s.count}
                            </td>
                        </tr>
                    ))}
                    {sortedSectors.length === 0 && (
                        <tr>
                            <td colSpan={3} style={{ textAlign: 'center', color: theme.sub, padding: 20 }}>
                                Aucune donnée sectorielle disponible
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
